import { render, staticRenderFns } from "./Workorders.vue?vue&type=template&id=6fa4a280&"
import script from "./Workorders.vue?vue&type=script&lang=js&"
export * from "./Workorders.vue?vue&type=script&lang=js&"
import style0 from "./Workorders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports